import { baseClasses, utilities } from '@weatherbug/common';
const { PulseBaseProvider } = baseClasses;
const { getDepth, getHeight, getSpeed } = utilities.unitConversion;
const { unitSystemType } = utilities.units;

const getSnowSkiUri = '/data/snowski/v1/ResortByLatitudeAndLongitude';

const getSnowSkiCacheKey = 'getSnowSki';

export class SnowSkiProvider extends PulseBaseProvider {
    constructor(baseUrl, authId, secret, options, logger) {
        super(baseUrl, authId, secret, options, logger);
        window.storage.sync[getSnowSkiCacheKey] = this.getSnowSkiSyncer.bind(this);
    }

    async getSnowSkiSyncer(params) {
        const { id, syncParams, resolve, reject } = params;
        const {latitude, longitude, rangeKm, maxResults, units} = syncParams;
        const queryParams = {latitude, longitude, rangeKm, maxResults};

        const snowSkiUnitConversionFunction = (resultArray) => {
            if (resultArray) {
                resultArray.forEach(result => {
                    const resortReport = result?.ResortData?.snowreport?.report;
                    const resortTerrain = result?.ResortData?.info?.terrain;
                    result.ResortData.snowreport.report.latestSnow = getDepth(resortReport?.latestSnow, units, true);
                    result.ResortData.snowreport.report.snowQuality.onSlope.middleDepth = getDepth(resortReport?.snowQuality.onSlope.middleDepth, units, true);
                    result.ResortData.snowreport.report.resortReportedWeather.windForceTop = getSpeed(resortReport?.resortReportedWeather.windForceTop, units, true);
                    result.ResortData.snowreport.report.resortReportedWeather.windForceBottom = getSpeed(resortReport?.resortReportedWeather.windForceBottom, units, true);
                    result.ResortData.info.terrain.elevationTop = getHeight(resortTerrain?.elevationTop, units, true);
                    result.ResortData.info.terrain.elevationBase = getHeight(resortTerrain?.elevationBase, units, true);
                    result.ResortData.info.terrain.verticalHeight = getHeight(resortTerrain?.verticalHeight, units, true);
                });
            }

            return resultArray;
        };

        return await super.syncData(syncParams.key, id, queryParams, getSnowSkiUri, resolve, reject, null, syncParams.pulseApi, null, snowSkiUnitConversionFunction, true);
    }

    // TECHDEBT: should we pass stdParams here?
    async getSnowSki(latitude, longitude, units = unitSystemType.english, rangeKm = 400, maxResults = 6, refresh) {
        const syncParams = {
            latitude,
            longitude,
            rangeKm,
            maxResults,
            units
        };
        const id = JSON.stringify(syncParams);

        if (refresh) {
            super.removeFromStorage(getSnowSkiCacheKey, id);
        }

        return await super.loadFromStorage(getSnowSkiCacheKey, id, syncParams);
    }
}
